import React, {useState, useContext} from "react"
import {buildClassList} from "../helpers/utilities"
import {PlusIcon, MinusIcon} from "../Icons"
import SiteContext from "../context/SiteContext"
import {CONTAINER_MD} from "../helpers/constants"

const FooterTopGroup = ({text, children}) => {
  
  const [open, setOpen] = useState(false)
  const {width} = useContext(SiteContext)
  
  
  const handle = (e) => {
    e.preventDefault()
    setOpen(!open)
  }
    
  const id = text.replace(/\s+/g, '-').toLowerCase()

  if (React.Children.count(children) === 0) return null
  var opts = {}
  if (width <= CONTAINER_MD) {
    opts['aria-controls'] = id
    opts['aria-expanded'] = open ? "true" : "false"
  } else {
    opts['role'] = "heading"
    opts['focusable'] = false
    opts['tabIndex'] = "-1"
  }
  return (
    <div className="footerTopGroup md:flex-1 md:pr-3 lg:pr-6">
      <h4 className="groupLabel inline-block uppercase mb-5 leading-none">
        {width < CONTAINER_MD &&
        <button 
          {...opts}
          onClick={handle} 
          aria-label={text + " section"}
          className="groupButton text-blue-500 text-left"
        >
          {!open && <PlusIcon className="groupButtonIcon md:hidden inline-block mr-2 top-2" focusable="false"/>}
          {open && <MinusIcon className="groupButtonIcon md:hidden inline-block mr-2 top-2" focusable="false"/>}
          <span className="groupLabelSpan text-black uppercase font-bold inline-block">{text}</span>
        </button>}

        {width > CONTAINER_MD &&
        <>
          <span className="groupLabelSpan text-black uppercase font-bold inline-block">{text}</span>
        </>}
      </h4>
      <ul 
          id={id} 
          className={buildClassList(
            "groupList ml-6 md:ml-0 md:block", 
            open ? "block" : "hidden" )}
      >
        {children}
      </ul>
    </div>
  )
}


export default FooterTopGroup